import Slider from "react-slick";
import { ProductSliderOne, ProductSliderTwo, Settings } from "../../../../../../data/applications/ECommerce";
import ProductSlider from "./ProductSlider";

// This component displays a product filter section with a slider containing two sets of products.
const PriceRange = () => {

  return (
    <div className="product-filter pb-0 new-products">
      <div className="owl-carousel owl-theme" id="testimonial">
        <Slider {...Settings}>
          <div className="item">
            {ProductSliderOne.map((item, index) => (
              <ProductSlider data={item} key={index} />
            ))}
          </div>
          <div className="item">
            {ProductSliderTwo.map((item, index) => (
              <ProductSlider data={item} key={index} />
            ))}
          </div>
        </Slider>
      </div>
    </div>
  );
};
export default PriceRange